import React, { useState, useEffect } from 'react'
import { supabase } from './supabase'
import Login from './screens/Login'
import Home from './screens/Home'
import './App.css'

function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f8f7',
      fontFamily: 'Jost, sans-serif',
      color: '#2d6973',
      fontSize: '14px'
    }}>
      Loading...
    </div>
  )

  return (
    <div className="App">
      {!session ? <Login /> : <Home session={session} />}
    </div>
  )
}

export default App